import React from "react";
import { Tooltip, Typography } from "antd";
import { PRIMARY_100, PRIMARY_700 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export const WaitListOnly = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("patientPotentialSavings.waitlist_only_tooltip")} placement={"top"}>
      <div
        {...props}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: PRIMARY_100,
          padding: "4px 8px",
          borderRadius: 4,
          gap: 5
        }}
      >
        <Text
          style={{
            fontSize: sizes.xsmall,
            fontWeight: fontWeights.semibold,
            color: PRIMARY_700,
            textTransform: "uppercase"
          }}
        >
          {t("patientPotentialSavings.waitlist_only")}
        </Text>
      </div>
    </Tooltip>
  );
};
